// Screen layout of the digital report form (the PDF keeps the template widths). Short single-line fields flow
// 2 per row on medium screens and 3 per row on wide ones; long content (texts, tables, lists) takes the full row.
const INLINE_TYPES = ['TEXT', 'NUMBER', 'MONEY', 'DATE', 'SELECT']

export const fieldCols = (field) => {
  const width = field.width || 'full'
  if (INLINE_TYPES.includes(field.type)) {
    if (width === 'third') return { cols: 12, sm: 6, md: 4, lg: 3 }
    if (width === 'half') return { cols: 12, sm: 6, lg: 4 }
    // "full" in the template means "long value" (name, address): half a row on screen is enough.
    return { cols: 12, md: 6 }
  }
  if (field.type === 'PHOTO') return { cols: 12, sm: 6, lg: 3 }
  if (field.type === 'CHOICE' && width === 'half') return { cols: 12, md: 6 }
  if (field.type === 'LIST' && width === 'half') return { cols: 12, md: 6 }
  return { cols: 12 }
}
